<template>
    <div id="modal-wrapper" :class="{'hidden' : !active}">
        <div id="overlay"></div> <!--extra div, so opacity won't affect sibling-->
        <div id="modal-container">
            <h3>Delete key?</h3>
            <p class="mt-s">This will result in a permanent deletion of this access key.</p>
            <div id="modal-buttons" class="mt-s">
                <button @click="cancelDelete" class="unstyled-button">Cancel</button>
                <button @click="deleteKey">Delete</button>
            </div>
        </div>
    </div>
</template>

<script>

import axios from "axios";

export default {
    name: 'DeletionModal',
    emits: ['active-key-deleted', 'expired-key-deleted'],
    data() {
        return {
            active: false,
            prjnum: '',
            access_key: '',
            isActive: Boolean
        }
    },
    methods: {
        deleteKey() {
            this.active = false;
            let url = '/api/v1/project/' + this.prjnum + '/key/' + this.access_key;

            axios.delete(url)
            .then(() => {
                if (this.isActive) this.emitter.emit('active-key-deleted'); //for alert on ProjectPage and routing to keys on parent
                else this.emitter.emit('expired-key-deleted'); //for alert on ProjectPage and reloading keys
            })
            .catch(error => console.log(error.response.status, error.response.statusText));
        },
        cancelDelete() { //remove modal
            this.active = false;
            this.prjnum = '';
            this.access_key = '';
        },
        getEData({prjnum, access_key, isActive}) {
            this.active = true;
            this.prjnum = prjnum;
            this.access_key = access_key;
            this.isActive = isActive;
        }
    },
    mounted() { //if bin icon or delete button pressed
        this.emitter.on('delete-clicked', ({prjnum, access_key, isActive}) => this.getEData({prjnum, access_key, isActive}));
    },
    beforeUnmount() {
        this.emitter.off('delete-clicked', ({prjnum, access_key, isActive}) => this.getEData({prjnum, access_key, isActive}));
    }
}

</script>

<style>

#modal-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

#overlay {
    width: 100%;
    height: 100%;
    background-color: black;
    opacity: 0.4;
}
#modal-container {
    position: absolute;
    width: max-content;
    background-color: var(--white);
    padding: 2rem 1.5rem;
    border-radius: 4px;
}
#modal-buttons {
    display: flex;
    flex-direction: row;
    gap: 1.5rem;
    justify-content: flex-end;
}

.hidden {
    visibility: hidden;
}

@media screen and (max-width: 600px) {
   #modal-container {
        width: min-content;
   }
}

</style>
